import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    // 모든 package component
    async getPackageComponentList ({ state }, spaceid) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-guest-package',
          func: 'get-package-component-list',
          id: store.state.authentication.requestId,
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex.response
      }
    },
    // 모든 mypackage 서비스
    async getMyPackageSetting ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-guest-package',
          func: 'get-my-package-setting',
          id: store.state.authentication.requestId
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex.response
      }
    },
    // 모든 mypackage 서비스
    async setMyPackageSetting ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-guest-package',
          func: 'set-my-package-setting',
          id: store.state.authentication.requestId,
          payload: data
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex.response
      }
    },
  },
  getters: {
    getPackageResultData: () => (code) => {
      let result = true
      switch (code) {
        case 250:
          result = 'package_nodata' // 패키지 서비스를 찾을 수 없음
          break
        case 251:
          result = 'package_already' // 마이패키지가 이미 있어 생성할 수 없음
          break
        case 301:
          result = 'package_send_fail' // 전송정보가 유효하지 않음
          break
        case 601:
          result = 'package_invalid_data' // 유효하지 않은 요청 정보
          break
        // 351~500까지는 공통에러
        case 351:
          result = 'invalid_format' // 형식에 맞지 않는 정보(invalid format)
          break
        case 401:
          result = 'inactivate' // 비활성화 또는 서비스 하지 않는 사이트
          break
        case 403:
          result = 'invalid_request' // 유효하지 않은 요청 데이터
          break
        case 405:
          result = 'invalid_site' // 사이트 정보가 없음
          break
        case 406:
          result = 'not_found_data' // 데이터가 없음
          break
        case 500:
          result = 'system_error' // 내부 오류
          break
      }
      return result
    }
  }
}
